<!-- login.component.html -->


<div class="max-w-xl m-3 p-10 bg-blue-400 border border-[var(--borderColor)]">
    <div class="flex items-center gap-4 mb-4">
      <img
        class="w-14 h-14 object-contain"
        src="assets/icons/note-icon-512x512.png"
        alt="Note icon"
      />
      <h2 class="m-0 text-4xl font-bold">Login</h2>
    </div>
    <div class="mb-4" role="group" aria-label="Database">
      <div class="mb-1 text-sm font-semibold">Database</div>
      <div class="inline-flex overflow-hidden rounded border border-[var(--borderColor)]">
        <button
          *ngFor="let t of dataTargets"
          type="button"
          class="min-h-[44px] min-w-[88px] px-4 text-sm font-semibold cursor-pointer border-0"
          [ngClass]="t === dataTarget.current
            ? (t === 'DEV' ? 'bg-amber-400 text-black' : 'bg-primary-700 text-white')
            : 'bg-white/80 text-gray-900'"
          [attr.aria-pressed]="t === dataTarget.current"
          (click)="dataTarget.requestSwitch(t)">
          {{ t }}
        </button>
      </div>
      <div class="mt-1 text-sm">Client: <strong>{{ clientEnv }}</strong> build</div>
      <div *ngIf="dataTarget.current === 'DEV'" class="mt-1 text-sm font-semibold">
        DEV database — test data, not your live notes.
      </div>
    </div>
    <form (submit)="onLogin()">
      <div>        
        <label class="p-2 w-24 text-right" for="username">Username:</label>            
        <input
          class="my-2 h-10 p-2 w-60 max-h-10 border border-[var(--borderColor)] bg-white/80 text-gray-900 placeholder-gray-500 focus:border-primary-500 focus:ring-2 focus:ring-primary-200"
          type="text"
          id="username"
          [(ngModel)]="username"
          name="username"
          #usernameInput
          required
          autofocus
        />
      </div>
      <div>
        <label class="p-2 w-24 text-right" for="password">Password:</label>
        <input
          class="my-2 h-10 p-2 w-60 max-h-10 border border-[var(--borderColor)] bg-white/80 text-gray-900 placeholder-gray-500 focus:border-primary-500 focus:ring-2 focus:ring-primary-200"
          type="password"
          id="password"
          [(ngModel)]="password"
          name="password"
          required
        />
      </div>
      <button
        pButton
        class="mt-5 w-40 p-button-rounded p-button-lg font-semibold border border-primary-300 bg-primary-50 text-primary-700 hover:bg-primary-100"
        type="submit"
        [disabled]="loading"
      >
        {{ loading ? 'Logging in...' : 'Login' }}
      </button>
      <div
        *ngIf="errorMessage"
        class="mt-4 flex items-center gap-2 rounded border border-red-300 bg-red-50 p-3 text-sm font-medium text-red-800"
      >
        <i class="fas fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
      <div class="mt-4 text-sm">
        Don't have an account?
        <a routerLink="/register" class="underline text-primary-900">Register</a>
      </div>
    </form>
  </div>
